export default __webpack_public_path__ + "static/media/iconRemoverLink.17bce701.svg";